var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompassIcon = function SvgCompassIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84.911,
    height: 84.911,
    viewBox: "0 0 84.911 84.911",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ca0928;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-60.653,587.019a42.471,42.471,0,0,0-42.456,42.456A42.471,42.471,0,0,0-60.653,671.93,42.471,42.471,0,0,0-18.2,629.474,42.471,42.471,0,0,0-60.653,587.019Zm0,76.42a34.009,34.009,0,0,1-33.965-33.964A34.01,34.01,0,0,1-60.653,595.51a34.01,34.01,0,0,1,33.965,33.965A34.009,34.009,0,0,1-60.653,663.439ZM-84,652.825l31.884-14.817L-37.3,606.124l-31.884,14.817Zm23.35-28.021a4.657,4.657,0,0,1,4.67,4.67,4.657,4.657,0,0,1-4.67,4.67,4.657,4.657,0,0,1-4.67-4.67A4.657,4.657,0,0,1-60.653,624.8Z",
    transform: "translate(103.109 -587.019)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompassIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/compass-icon.69d0a492.svg";
export { ForwardRef as ReactComponent };